import { BuildInfo } from './InternalTypes';
import { Util } from './Util';

export class LibInfo {
	public static getBuildInfo(): BuildInfo {
		return {
			name: 'pxapi',
			version: '3.0.7'
		};
	}

	public static getBuildInfoString(): string {
		return `${this.getBuildInfo().name}/${this.getBuildInfo().version}`;
	}

	public static getGlobalBuildInfo(): string {
		// Ensure value extended by wrapper-API/client is returned.
		const globalInfoValue = Util.getGlobalContextValue('qtx', 'info');
		if (globalInfoValue && globalInfoValue.pxclient) {
			return globalInfoValue.pxclient;
		}
		return this.getBuildInfoString();
	}

	public static setInfoData() {
		const globalInfo = Util.ensureGlobalContext('qtx', 'info');
		globalInfo.pxclient = this.getBuildInfoString();
	}
}
